<template>
  <Toast/>
  <div class="row">
    <div class="col">
      <h2 class="titre">Ajout un billet</h2>
    </div>
  </div>
  <ModifierChamps ref="modifierChamps" :billet="billet" :isModifier="false"/>
  <ButtonBar @fermer="fermer" @ajouter="ajouter" :isSauvegardeEnCours="isSauvegardeEnCours"/>
  <DialogConfirmation ref="dialogConfirmation"/>
</template>

<script>
import axios from 'axios'
import {mapGetters} from 'vuex'
import ButtonBar from '../../../components/dossier/Ajouter/ButtonBarBillet.vue'
import ModifierChamps from '../../../components/dossier/Modifier/ModifierChampsBillet.vue'
import DialogConfirmation from '../../../components/Commun/DialogConfirmation.vue'

export default {
  emits: ['rechercher', 'effacerCriteres'],
  components: {
    ButtonBar,
    ModifierChamps,
    DialogConfirmation,
  },
  data() {
    return {
      isSauvegardeEnCours: false,
    };
  },
  computed: {
    ...mapGetters({
      jeton: 'cardex/jeton',
      profil: 'cardex/profil',
      billet: 'billet/billet'
    })
  },
  beforeMount() {

    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.$store.dispatch('billet/resetBilletStoredAction', {
      cleDossier: this.$route.params.cleDossier,
      siteDossier: this.$route.params.siteDossier,
      provenanceDetaillant: {numeroFiche: null, nom: null},
      validationDetaillant: {numeroFiche: null, nom: null},
      verificationDetaillant: {numeroFiche: null, nom: null},
      fautifDetaillant: {numeroFiche: null, nom: null},
    });
    this.isRechercheDataLoading = false;
  },
  mounted() {
    this.$root.$refs.breadcrumbComp.ajout("Ajouter un billet");
  },
  methods: {
    ajouter() {
      this.isSauvegardeEnCours = true;
      this.$store.commit('billet/UPDATE_BILLET', this.$refs.modifierChamps.getBilletLocal());
      this.$store.dispatch('billet/ajouterBilletAction', {
        cle: this.$route.params.cle,
        site: this.$route.params.site,
      }).then((res) => {
        this.$root.$refs.messagesComp.messagesList = res.data.messages
        if (res?.data?.messages.length == 0) {
          this.$toast.add(
              {
                severity: 'success',
                summary: 'Ajouter',
                detail: 'Le billet a été ajouté.',
                life: 6000
              });
          this.fermer();
        }
        this.isSauvegardeEnCours = false;
      });
    },
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
  },
  beforeRouteLeave(to, from, next) {
    return this.$refs.dialogConfirmation.confirmer(next, this.billet, this.$refs.modifierChamps.getBilletLocal());
  },
};
</script>
